function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
jQuery(document).ready(function() {
    console.log("ready!");
    var Accordion = /*#__PURE__*/ function() {
        "use strict";
        function Accordion(domNode) {
            _class_call_check(this, Accordion);
            this.rootEl = domNode;
            this.buttonEl = this.rootEl.querySelector("button[aria-expanded]");
            var controlsId = this.buttonEl.getAttribute("aria-controls");
            this.contentEl = document.getElementById(controlsId);
            this.open = this.buttonEl.getAttribute("aria-expanded") === "true";
            // add event listeners
            this.buttonEl.addEventListener("click", this.onButtonClick.bind(this));
        }
        _create_class(Accordion, [
            {
                key: "onButtonClick",
                value: function onButtonClick() {
                    this.toggle(!this.open);
                }
            },
            {
                key: "toggle",
                value: function toggle(open) {
                    // don't do anything if the open state doesn't change
                    if (open === this.open) {
                        return;
                    }
                    // update the internal state
                    this.open = open;
                    // handle DOM updates
                    this.buttonEl.setAttribute("aria-expanded", "".concat(open));
                    if (open) {
                        this.contentEl.removeAttribute("hidden");
                    } else {
                        this.contentEl.setAttribute("hidden", "");
                    }
                }
            },
            {
                // Add public open and close methods for convenience
                key: "open",
                value: function open() {
                    this.toggle(true);
                }
            },
            {
                key: "close",
                value: function close() {
                    this.toggle(false);
                }
            }
        ]);
        return Accordion;
    }();
    // init accordions
    var accordions = document.querySelectorAll(".filter-container .accordion h3");
    accordions.forEach(function(accordionEl) {
        new Accordion(accordionEl);
    });
});
